import React, { useEffect, useRef, useState } from "react";
import { Keyboard, View } from 'react-native'
import { colorList } from 'utils/colors'
import Input from "theme/Input";
import Text from "theme/Text";
import * as Animatable from 'react-native-animatable'
import Button from 'theme/Button'
import _ from 'lodash'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import i18n from 'utils/i18n'
import { styles } from "../styles/styles";
import HelperEncryption from 'utils/helper-encryption'
import EmployeeUtil from 'utils/employee-util'
import { DomainStatus } from '../components/Domain'
import HelperAlerts from 'utils/HelperAlerts'
import { TESTID } from '_shared/config/testID'
import HelperString from 'utils/helper-string'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'



export const EmailStatus = {
	UNKOWN: 'unknown',
	VERIFIED: 'verified',
	ERROR: 'error'
}

const Email = ( { onMailChange, onMailStatusChange, domainStatus } = {} ) => {
	
	const verifying = useRef( false );
	const mounted = useRef( true );
	const [ mailValue, setMailValue ] = useState( '' );
	const mail = useRef( '' )
	
	//const [ mail, setMail ] = useState( '' );
	const [ mailVerifying, setMailVerifying ] = useState( null );
	const [ mailVerified, setMailVerified ] = useState( null );
	const [ mailStatus, setMailStatus ] = useState( EmailStatus.UNKOWN )
	const [ mailGraphqlRunning, setMailGraphqlRunning ] = useState( false );
	const [ mailGraphqlResult, setMailGraphqlResult ] = useState( null );
	
	useEffect( () => {
		mounted.current = true;
		return () => {
			mounted.current = false;
		};
	}, [] );

	const trimMail = ( newMail ) => {
		return newMail.trim().toLowerCase()
	}
	
	const setMail = ( newMail ) => {
		newMail = trimMail( newMail )
		
		// Set the email with TLD ( when tld not null )
		const emailTLD = HelperSetting.get( settingsConstants.EMAIL_TLD );
		if( emailTLD !== null && !_.isEmpty( emailTLD ) ) {
			newMail += emailTLD
		}
		
		mail.current = trimMail( newMail )
		
		onMailChange( mail.current );
	}
	
	const onChange = ( newMail = "" ) => {
		setMailValue( newMail );
		
		setMail( newMail )
		setMailStatus( EmailStatus.UNKOWN )
		setMailVerified( false );
		setMailGraphqlResult( null )
	};
	
	const isEmailValid = () => {
		return String( mail?.current ?? '' )
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
	}
	
	const verify = () => {
		if( !isEmailValid() ) {
			setMailVerifying( false );
			return;
		}
		
		if( verifying.current ) return;
		verifying.current = true;
		const submittedMail = mail.current;
		const finish = () => {
			verifying.current = false;
			if( !mounted.current ) return false;
			setMailVerifying( false );
			setMailGraphqlRunning( false );
			return submittedMail === mail.current;
		};

		// Reset key! !! important !!
		HelperEncryption.resetKey();
		
		Keyboard.dismiss();
		
		//let accessTo = HelperPlatform.isNotWeb() ? 'app' : 'management';
		let accessTo = 'app';
		
		EmployeeUtil.sendToken( submittedMail, {
			accessTo: accessTo,
			onStart: () => {
				setMailVerified( false );
				setMailVerifying( true );
				setMailGraphqlRunning( true );
				setMailGraphqlResult( null );
			},
			onSuccess: result => {
				if( !finish() ) return;
				switch( result.status ) {
					case 'success':
						setMailGraphqlResult( _.get( result, 'sent_to', { method: 'unknown', recipient: 'unknown@unknown' } ) )
						setMailStatus( EmailStatus.VERIFIED );
						setMailVerified( true );
						setMailVerifying( false )
						setMailGraphqlRunning( false );
						break;
					
					default:
						setMailStatus( EmailStatus.ERROR );
						setMailVerified( false );
						setMailVerifying( false )
						setMailGraphqlRunning( false );
						
						const error = _.isEmpty( result.error ) ? 'something_went_wrong' : result.error;
						triggerAlert(
							i18n.t(`page.authentication.domain.alerts.${error}.title`),
							i18n.t(`page.authentication.domain.alerts.${error}.message`)
						);
						break;
				}
			},
			onError: result => {
				if( !finish() ) return;
				setMailVerifying( false );
				setMailGraphqlRunning( false );
				setMailStatus( EmailStatus.ERROR );
				
				triggerAlert(
					i18n.t('page.authentication.domain.alerts.something_went_wrong.title'),
					i18n.t('page.authentication.domain.alerts.something_went_wrong.message')
				);
			}
		} );
	};
	
	const getAccessoryLeft = () => {
		const items = [];
		
		switch( true ) {
			case mailVerified:
				items.push(
					<Icon icon={ IconSystemConstants.SUCCESS } key={ HelperString.hash( 'mail_icon_success' ) } style={ [ styles.icon, styles.iconGreen ] } />
				);
				break;
				
			case mailVerifying:
				items.push(
					<Animatable.Text
						key={ HelperString.hash( 'mail_icon_verifying' ) }
						animation={ 'rotate' }>
						<Icon icon={ IconSystemConstants.SPINNER } style={ [ styles.icon, styles.iconOrange ] } />
					</Animatable.Text>
				);
				break;
			
			case domainStatus === DomainStatus.ERROR:
				items.push(
					<Icon icon={ IconSystemConstants.WARNING } key={ HelperString.hash( 'mail_icon_warning' ) } style={ [ styles.icon, styles.iconRed ] } />
				);
				break;
			
			default:
				items.push(
					<Icon icon={ IconSystemConstants.SUCCESS } key={ HelperString.hash( 'mail_icon_default' ) } style={ [ styles.icon, styles.iconGrey ] } />
				)
		}
		
		return items;
	};
	
	const getAccessoryRight = () => {
		const emailTLD = HelperSetting.get( settingsConstants.EMAIL_TLD );
		if( _.isEmpty( emailTLD ) ) {
			return null;
		}

		return (
			<Text
				style={ styles.textAccessoryRight }
				category={"s1"}>
				
				{ emailTLD }
			</Text>
		);
	}
	
	const triggerAlert = ( title, message ) => {
		HelperAlerts.alert( title, message )
	}
	
	useEffect( onMailStatusChange.bind( this, mailStatus, mailGraphqlResult ), [ mailStatus, mailGraphqlResult ] )
	
	const items = [
		<Animatable.View
			key={ HelperString.hash( "mail_animatable_input" ) }
			animation={ "bounceIn" } >
			
			<View style={ styles.itemContainer }>
				<Input
					autoCorrect={ false }
					spellCheck={ false }
					style={ styles.textInput }
					placeholder={ i18n.t('page.authentication.domain.email') }
					value={ mailValue }
					onChangeText={ onChange }
					accessoryLeft={ getAccessoryLeft }
					accessoryRight={ getAccessoryRight }
					accessoryRightWidth="auto"
					returnKeyType={ "go" }
					onSubmitEditing={ verify }
					testID={ TESTID.AUTHENTICATION.EMAIL_INPUT }
				/>
			</View>
		</Animatable.View>
	];
	
	if( domainStatus === DomainStatus.VERIFIED && !mailVerified && isEmailValid() ) {
		items.push(
			<Animatable.View
				key={ HelperString.hash( "mail_animatable_button" ) }
				animation={ "bounceIn" }>
				
				<View style={ styles.itemContainer }>
					<Button
						disabled={ !isEmailValid() || mailGraphqlRunning }
						isLoading={ mailVerifying }
						isLoadingText={ i18n.t('page.authentication.domain.button_loading') }
						onPress={ verify }>
						
						{ i18n.t('page.authentication.domain.button') }
					</Button>
				</View>
			</Animatable.View>
		);
	}
	
	return items;
}

export default Email;
